import React from 'react';
import {useWindowSize} from "../../../hooks";
import {Container} from "react-bootstrap";

export function ABCardShop({className, styleWidth = "20rem", children, title}) {
    const {width} = useWindowSize()
    const useBorder = width <= 576 ? "w-100 " : "border rounded shadow-sm"
    const styleW = width <= 576 ? "" : styleWidth

    return <div className={`d-flex flex-column bg-light-subtle p-3 mb-2 ${useBorder} ${className}`} style={{width: styleW}}>
        {title && <TitleSections title={title} />}
        {children}
    </div>
}

function TitleSections({title, className}) {
    return <div className={`text-start fs-4 fw-bold mb-2 ms-2 ms-sm-0 ${className}`}>{title}</div>
}

export function ABContainer({children}) {
    const {width} = useWindowSize()
    if (width < 576)
        return children
    else
        return <Container fluid="lg">{children}</Container>

}

export function ABCardShopBottom({className, styleWidth = "20rem", children}) {
    const {width} = useWindowSize()
    const useBorder = width <= 576 ? "w-100 " : "border rounded shadow-sm"
    const styleW = width <= 576 ? "" : styleWidth

    return <div className={`d-flex bg-light-subtle p-3 mb-2 ${useBorder} ${className}`} style={{width: styleW}}>{children}</div> // bg-light-subtle
}